import { useState } from "react";
import { fmtRub } from "../../lib/format";
import type { MonthBucket } from "./statsData";

// Помесячный реализованный P&L: бары вверх (прибыль) / вниз (убыток) от нулевой
// линии по центру. Высота — доля от максимального по модулю месяца.
export function MonthlyBars({ months }: { months: MonthBucket[] }) {
  const [hi, setHi] = useState<number | null>(null);
  const max = months.reduce((m, b) => Math.max(m, Math.abs(b.value)), 0) || 1;
  const cols = `repeat(${months.length}, 1fr)`;

  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: cols,
          gap: 6,
          height: 140,
          alignItems: "center",
          borderTop: "1px dashed var(--line)",
          borderBottom: "1px dashed var(--line)",
          position: "relative",
        }}
      >
        {months.map((m, i) => {
          const barH = m.value === 0 ? 0 : Math.max(3, (Math.abs(m.value) / max) * 60);
          const positive = m.value >= 0;
          return (
            <div
              key={m.ymKey}
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                cursor: "pointer",
                filter: hi !== null && hi !== i ? "opacity(0.4)" : "none",
                transition: "filter 0.15s",
              }}
              onMouseEnter={() => setHi(i)}
              onMouseLeave={() => setHi(null)}
            >
              {positive ? (
                <>
                  <div style={{ flex: 1 }} />
                  <div
                    style={{
                      height: barH,
                      background: hi === i ? "var(--accent)" : "var(--good)",
                      borderRadius: "3px 3px 0 0",
                      marginTop: "auto",
                    }}
                  />
                  <div style={{ height: "50%" }} />
                </>
              ) : (
                <>
                  <div style={{ height: "50%" }} />
                  <div
                    style={{
                      height: barH,
                      background: hi === i ? "var(--accent)" : "var(--bad)",
                      borderRadius: "0 0 3px 3px",
                    }}
                  />
                  <div style={{ flex: 1 }} />
                </>
              )}
            </div>
          );
        })}
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            top: "50%",
            borderTop: "1.5px solid var(--ink-soft)",
            pointerEvents: "none",
          }}
        />
      </div>
      <div style={{ display: "grid", gridTemplateColumns: cols, gap: 6, marginTop: 6 }}>
        {months.map((m) => (
          <div
            key={m.ymKey}
            style={{ fontSize: 10.5, color: "var(--ink-soft)", textAlign: "center" }}
          >
            {m.label}
          </div>
        ))}
      </div>
      {hi !== null && (
        <div
          style={{
            position: "absolute",
            left: `calc(${((hi + 0.5) / months.length) * 100}% - 66px)`,
            top: -46,
            width: 132,
            background: "var(--ink)",
            color: "#fff",
            borderRadius: 6,
            padding: "6px 10px",
            fontSize: 12,
            pointerEvents: "none",
            boxShadow: "0 4px 14px rgba(0,0,0,0.28)",
          }}
        >
          <div style={{ opacity: 0.7, fontSize: 10.5, letterSpacing: "0.05em" }}>
            {months[hi].label}
          </div>
          <div
            className="mono"
            style={{
              fontSize: 13,
              marginTop: 2,
              color: months[hi].value >= 0 ? "#7ee7a9" : "#f3a98e",
            }}
          >
            {months[hi].value >= 0 ? "+" : ""}
            {fmtRub(months[hi].value)}
          </div>
        </div>
      )}
    </div>
  );
}
